"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateLibrary = void 0;
const databases_templates_1 = require("databases.templates");
const resource_loader_1 = require("./resource_loader");
/** Access a collection of templates by templateId + version. */
class TemplateLibrary {
    constructor(storage) {
        this.manifestDatabase = storage.getDatabase(databases_templates_1.COLLECTION_NAME);
        this.resourcesBucket = storage.getBucket(databases_templates_1.BUCKET_NAME);
    }
    /**
     * Stores a template in the library.
     *
     * @param templateId Template Id and version in the format" id~version
     */
    storeTemplate(templateId, manifest, resources) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.manifestDatabase.getEntry(templateId).set(manifest);
            const templateDirectory = this.resourcesBucket.getDir(templateId);
            console.log(templateDirectory);
            yield Promise.all(Object.entries(resources).map(([path, content]) => templateDirectory.getFile(path).upload(content)));
        });
    }
    /**
     * Gets the manifest for the specified template.
     *
     * @param id Template Id and version in the format" id~version
     */
    getManifest(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const manifest = yield this.manifestDatabase.getEntry(id).get();
            if (manifest === undefined) {
                throw new Error(`Cannot find a manifest for template ${id}`);
            }
            return manifest;
        });
    }
    /** Fetches all the manifest files keyed by template id */
    loadAllManifests() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.manifestDatabase.getDataEntries();
        });
    }
    /**
     * Lists all the templates available in this library.
     */
    listTemplates() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.manifestDatabase.getEntries()).map(({ id }) => id);
        });
    }
    /**
     * Gets the resource loader for the specified template.
     *
     * @param id Template Id and version in the format" id~version
     */
    getResourceLoader(id) {
        return new resource_loader_1.ResourceLoader(this.resourcesBucket, id);
    }
}
exports.TemplateLibrary = TemplateLibrary;
//# sourceMappingURL=template_library.js.map